<template>
	<div class = "date-selector-wrapper">
		<div class ="form-group row" v-if="renderComponent">
			<div class="col-sm-2">
				<p>StartDate</p>
			</div>
			<div class="col-sm-4">
				<b-form-datepicker
					:id="'start-date-selector-' + type"
					name="startDate"
					placeholder="Start date"
					class="date_wrapper padding-custom"
					v-model="start_date"
					menu-class="w-100"
					size="sm"
					:date-format-options="{day: '2-digit',  month: '2-digit',  year: 'numeric' }"
					calendar-width="200%"
					:hide-header="true"
					:today-button="false"
					:min="todays_date"
					v-bind:disabled="hideStartDate"
					v-bind:class="hideStartDate ? 'date-disabled' :''"
					locale="en"
				></b-form-datepicker>
				 <!-- <input type = "date" name = "startDate" class = "form-control" v-model = "start_date" :min = "todays_date" id="start-date-selector"> -->
			</div>

			<div class="col-sm-2 " v-if = "showOthers" >
				<span>
					<input type = "radio"  value = "today" v-model = "checkedStartdate">
					Today
				</span>
			</div>
			<div class = "col-sm-2" v-if = "showOthers" >
				<span>
					<input type = "radio"  value = "tomorrow" v-model = "checkedStartdate" >
					Tomorrow
				</span>
			</div>
		</div>
		<div class = "form-group row" v-if="renderComponent">
			<div class = "col-sm-2"><p>End Date</p></div>
			<div class = "col-sm-4">
				<b-form-datepicker
					:id="'end-date-selector_' + type"
					name="enDate"
					placeholder="End date"
					class="date_wrapper padding-custom"
					v-model="end_date"
					menu-class="w-100"
					size="sm"
					:date-format-options="{day: '2-digit',  month: '2-digit',  year: 'numeric' }"
					calendar-width="200%"
					:hide-header="true"
					:today-button="false"
					:min="findMinDate()"
					locale="en"
				></b-form-datepicker>
				<!-- <input type = "date" name = "enDate" :min = "findMinDate()" class = "form-control" v-model = "end_date"  > -->
			</div>
		</div>
		<div class = "form-group row" v-if = "type == 'ams_mnso'">
			<div class = "col-sm-2"><p>Start Time</p></div>
			<div class="col-sm-4"  style = "" v-if = "type == 'ams_mnso'">
				<!-- <span>
					<vue-timepicker v-model = "checked_mnso_start_time"  :minute-interval="15" hide-clear-button></vue-timepicker>
				</span> -->
				<multiselect
					v-model="startTimeObj"
					:options="time_list"
					:searchable="true"
					placeholder="HH:mm"
					ref="multiselect"
					track-by="hourminute"
					label="hourminute"
					open-direction="bottom"
					class="form-control multi-dropdown"
					selectLabel
					deselectLabel
					selectedLabel
					autocomplete="off"
					style="max-height:40px;"
					:multiple="false"
					:taggable="false"
					id="startTime"
					@input="setMNSOTime"
				></multiselect>
			</div>
			<div class = "col-sm-2"><p>End Time</p></div>
			<div class="col-sm-2"  style = "" v-if = "type == 'ams_mnso'">

				<!-- <span>
					<vue-timepicker v-model = "checked_mnso_end_time"  :minute-interval="15" hide-clear-button></vue-timepicker>
				</span> -->
				<multiselect
					v-model="endTimeObj"
					:options="time_list"
					:searchable="true"
					placeholder="HH:mm"
					ref="multiselect"
					track-by="hourminute"
					label="hourminute"
					open-direction="bottom"
					class="form-control multi-dropdown"
					selectLabel
					deselectLabel
					selectedLabel
					autocomplete="off"
					style="max-height:40px;"
					:multiple="false"
					:taggable="false"
					id="endTime"
					@input="setMNSOTime"
				></multiselect>
			</div>
			<div class = "col-sm-2" style = "color:red"><p>Time in CST</p></div>
		</div>


	</div>
</template>

<script>

var moment = require("moment");
import Multiselect from "vue-multiselect";
// import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

export default {
  name : 'MNSODateSelector',
  components:{
	//VueTimepicker,
	Multiselect
  },
  data(){
    return{
		start_date : '',
		end_date : '',
		checkedStartdate : '',
		todays_date : '',
		showOthers : true,
		checked_mnso_start_time: '',
		checked_mnso_end_time: '',
		time_list : [],
		hour_gap:1,
		minute_gap:0,
		start_min:15,
		start_hour:0,
		end_min:15,
		end_hour:23,
		startTimeObj:{
			hourminute :'00:15'
		},
		endTimeObj:{
			hourminute :'06:15'
		},
		renderComponent:true,
		hideStartDate: false
    }
  },
  props:{
	  type : String,
	  isEdit : Boolean,
	  start_date_ams : Date,
	  end_date_ams : Date,
	  start_date_ml : Date,
	  end_date_ml : Date,
	  start_date_midnight : Date,
	  end_date_midnight : Date,
	  mnso_start_time: String,
	  mnso_end_time: String
  },
  mounted(){
	  	this.setTimeList()
	//  this.todays_date = moment(new Date()).utc().format("YYYY-MM-DD");
	//  this.todays_date = moment.utc().format("YYYY-MM-DD");
		this.todays_date = moment(Date.now()).format("YYYY-MM-DD")

		

	  if(this.type == "ams_shutoff" && (this.start_date_ams || this.end_date_ams)){
		  this.showOthers = false
		  this.start_date = this.start_date_ams;
		  this.end_date = this.end_date_ams ? this.end_date_ams : null;
	  }
	  if(this.type == "ams_mlso" && (this.start_date_ml || this.end_date_ml)){
		  this.showOthers = false
		  this.start_date =this.start_date_ml;
		  this.end_date = this.end_date_ml ? this.end_date_ml : null;
	  }
	  if(this.type == "ams_mnso" && (this.start_date_midnight || this.end_date_midnight)){
		  this.showOthers = false
		  this.start_date = this.start_date_midnight;
		  this.end_date = this.end_date_midnight ? this.end_date_midnight : null;
		  this.checked_mnso_start_time = this.mnso_start_time ? this.mnso_start_time : '';
		  this.checked_mnso_end_time = this.mnso_end_time ? this.mnso_end_time : '';
		  // if(this.mnso_time){
			//   let data = this.mnso_time.split(":");
			//   this.checked_mnso_start_time.hh = data[0]
			//   this.checked_mnso_start_time.mm = data[1]
		  // }
		//  this.mnso_time = this.mnso_time ? this.mnso_time : null
	  }
  },
   watch:{

	checked_mnso_start_time(){
		
		if(this.checked_mnso_start_time && this.checked_mnso_start_time.toString().length>5)
		{
			this.checked_mnso_start_time = this.checked_mnso_start_time.slice(0,5)
		}
		if(this.type == "ams_mnso" && this.checked_mnso_start_time){
		//	let result = Object.values(this.checked_mnso_start_time).join("");
			this.$emit("updateMNSOTime", this.checked_mnso_start_time)
		}
		else if(this.checked_mnso_start_time == ""){
			this.$emit("updateMNSOTime", null)
		}
		this.startTimeObj = {
			'hourminute' : this.checked_mnso_start_time
		}

	},
	checked_mnso_end_time(){
		
		if(this.checked_mnso_end_time && this.checked_mnso_end_time.toString().length>5)
		{
			this.checked_mnso_end_time = this.checked_mnso_end_time.slice(0,5)
		}
		if(this.type == "ams_mnso" && this.checked_mnso_end_time){
		//	let result = Object.values(this.checked_mnso_end_time).join("");
			this.$emit("updateMNSOEndTime", this.checked_mnso_end_time)
		}
		else if(this.checked_mnso_end_time == ""){
			this.$emit("updateMNSOEndTime", null)
		}
		this.endTimeObj = {
			'hourminute' : this.checked_mnso_end_time
		}
	},
	checkedStartdate(){
		if(this.checkedStartdate == 'today'){
			let todays_date = new Date()
			this.start_date = moment(Date.now()).format("YYYY-MM-DD")
		}
		else if(this.checkedStartdate == 'tomorrow') {
			this.start_date  = moment().add(1,'days').format("YYYY-MM-DD");
		}

		if(this.type == "ams_shutoff"){
			this.$emit('setAmsShutOffDate', {date:this.start_date, type:'start'})
		}
		else if(this.type == "ams_mlso"){
			this.$emit('setAmsMLSODate', {date:this.start_date, type:'start'})
		}
		else if(this.type == "ams_mnso"){
			this.$emit('setMNSODate', {date:this.start_date, type:'start'})
		}
	},
	start_date(){
		let today = moment(new Date()).format('YYYY-MM-DD');
		let tomorrow =  moment().add(1,'days').format("YYYY-MM-DD");
		this.hideStartDate = false
		if(this.start_date != today && this.start_date != tomorrow && !moment(this.start_date).isBefore(moment(today))){
			this.checkedStartdate = ''
			if(this.type == "ams_shutoff"){
				this.$emit('setAmsShutOffDate', {date:this.start_date, type:'start'})
			}
			else if(this.type == "ams_mlso"){
				this.$emit('setAmsMLSODate', {date:this.start_date, type:'start'})
			}
			else if(this.type == "ams_mnso"){
				this.$emit('setMNSODate', {date:this.start_date, type:'start'})
			}
		}
		else if(this.start_date == today && this.start_date != tomorrow ){
			this.checkedStartdate = 'today'
		}
		else if(this.start_date != today && this.start_date == tomorrow ){
			this.checkedStartdate = 'tomorrow'
		}
		else if(moment(this.start_date).isBefore(moment(today))){
			//this.disableSelectStart = true
			document.getElementById("start-date-selector").disabled = true;
			this.hideStartDate = true
		}
		if(this.end_date){
			if(moment(this.end_date).isBefore(moment(this.start_date))){
				if(this.type == "ams_shutoff"){
					this.end_date = ''
					this.$emit('setAmsShutOffDateNull')
				}
				else if(this.type == "ams_mlso"){
					this.end_date = ''
					this.$emit('setAmsMLSODateNull')
				}
				else if(this.type == "ams_mnso"){
					this.end_date = ''
					this.$emit('setMNSODateNull')
				}
			}

		}
		this.forceRerender()

	},
	end_date(){
		if(this.type == "ams_shutoff"){
			this.$emit('setAmsShutOffDate', {date:this.end_date, type:'end'})
		}
		else if(this.type == "ams_mlso"){
			this.$emit('setAmsMLSODate', {date:this.end_date, type:'end'})
		}
		else if(this.type == "ams_mnso"){
			this.$emit('setMNSODate', {date:this.end_date, type:'end'})
		}
		this.forceRerender()
	}

  },
  methods : {
	  forceRerender () {
			this.renderComponent = false;
			this.$nextTick (() => {
				this.renderComponent = true;
			});
		},
	  setMNSOTime(time,id){
		  
		  if(id=='startTime'){
			  if(time){
				  this.checked_mnso_start_time = time['hourminute']
			  }
			  else{
				  this.checked_mnso_start_time = ''
			  }
		  }
		  if(id=='endTime'){
			  if(time){
				  this.checked_mnso_end_time = time['hourminute']
			  }
			  else{
				  this.checked_mnso_end_time = ''
			  }
		  }
	  },
	  setTimeList(){
		  this.time_list = []
		  for(var i=this.start_hour;i<=this.end_hour;i=i+this.hour_gap){
			  let obj = {}
			  let min = this.start_min
			  obj['hour'] = i
			  obj['min'] = min
			  if(min<this.end_min){
				  min = min + this.minute_gap
			  }
			  else{
				  min = this.start_min
			  }
			  if(obj['hour'].toString().length == 1 ){
				  obj['hour'] = '0'+obj['hour']
			  }
			  obj['hourminute'] = obj['hour'] + ':' + obj['min']
			  this.time_list.push(obj)
		  }
	  },
	  getCurrent(){

		  	let tempDate =  moment().format("HH:mm")
		   //  let tempDate =  new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
			 let val = parseInt(tempDate.slice(-2))

			 let roundOf = val%10

			 if(roundOf == 0 || roundOf == 5 ){
				 val = val
			 }
			 else if(roundOf > 5){
				  val = (val-roundOf) + 10
			 }
			 else if(roundOf < 5){
				 val = (val-roundOf) + 5
			 }

			 if(val < 10){
				 val = '0'+val
			 }

			 console.log(tempDate.slice(0, -2) + val);

			return tempDate.slice(0, -2) + val;




	  },
	  findMinDate(){
		  let today = moment(new Date()).utc().format("YYYY-MM-DD");
		  if(this.start_date){
			  if(moment(this.start_date).isBefore(moment(today))){
				  return today
			  }
			  else{
				  return this.start_date
			  }
		  }
		  else{
			 return today
		  }
	  }
 }
}
</script>

<style lang="scss">
	.style-wrap{
		padding: 0 !important;
		text-align: center !important;
	}
	.date-selector-wrapper {
		.form-control{
			width : auto !important;
			/* padding: 0 !important; */
			height: auto !important;
		}
	}
	.vue__time-picker {
		input.display-time{
			margin: 0px !important;
			width: 85px !important;
			height: 30px !important;
			border-radius: 5px !important;
		}
	}
	.vue__time-picker {
		input.display-time.invalid:not(.skip-error-style) {
			border-color: rgb(206, 212, 218) !important;
			outline-color: rgb(206, 212, 218) !important;
		}
	}

	.date-selector-wrapper {
		.multiselect.form-control.multi-dropdown{
			max-height: 30px !important;
			max-width:90px !important;
			min-height: 30px !important;
		}
	}

	.date-selector-wrapper {
		.multiselect__select{
			max-height: 30px !important;
		}
	}

	.date-selector-wrapper {
		.multiselect__tags{
			min-height: 30px !important;
		}
	}
</style>
